module.exports = __webpack_public_path__ + "img/condicaoVentilacaoAzul.400893b3.svg";